// LoginSidebarWrapper.jsx
import React from 'react';
import Login from './Login';

const LoginSidebarWrapper = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Overlay background */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-40"
        onClick={onClose}
      ></div>

      {/* Sidebar */}
      <div className="fixed right-0 top-0 h-full w-96 bg-white shadow-lg z-50 overflow-auto p-6">
        <button
          onClick={onClose}
          aria-label="Close sidebar"
          className="mb-4 text-gray-700 hover:text-gray-900"
        >
          ✕ Close
        </button>

        <Login isSidebar />
      </div>
    </>
  );
};

export default LoginSidebarWrapper;